import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { host } from "../../config/Config";
import "./style.css";

export const AdminEducationApplications = () => {
    const navigate = useNavigate();
    const [applications, setApplications] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [filterStatus, setFilterStatus] = useState("ALL");
    const [confirmDialog, setConfirmDialog] = useState({
        show: false,
        applicationId: null,
        newStatus: null,
        message: "",
        isDelete: false,
    });

    useEffect(() => {
        fetchApplications();
    }, [filterStatus]);

    const fetchApplications = async () => {
        try {
            const token = localStorage.getItem("jwt-vlada");
            if (!token) {
                navigate("/login");
                return;
            }

            const url =
                filterStatus === "ALL"
                    ? `${host}/api/v1/education-applications`
                    : `${host}/api/v1/education-applications?status=${filterStatus}`;

            const response = await fetch(url, {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            });

            if (response.ok) {
                const data = await response.json();
                setApplications(data);
            } else if (response.status === 401) {
                navigate("/login");
            } else {
                setError("Došlo je do greške pri učitavanju prijava.");
            }
        } catch (err) {
            console.error("Error fetching applications:", err);
            setError("Došlo je do greške pri učitavanju prijava.");
        } finally {
            setLoading(false);
        }
    };

    const updateApplicationStatus = async (applicationId, newStatus) => {
        const statusMessages = {
            APPROVED: "odobriti",
            REJECTED: "odbiti",
            PENDING: "vratiti na čekanje",
        };

        setConfirmDialog({
            show: true,
            applicationId,
            newStatus,
            message: `Da li ste sigurni da želite da ${statusMessages[newStatus]} ovu prijavu?`,
            isDelete: false,
        });
    };

    const deleteApplication = async (applicationId) => {
        setConfirmDialog({
            show: true,
            applicationId,
            newStatus: null,
            message:
                "Da li ste sigurni da želite da uklonite ovu prijavu iz liste?",
            isDelete: true,
        });
    };

    const confirmStatusUpdate = async () => {
        const { applicationId, newStatus, isDelete } = confirmDialog;

        if (isDelete) {
            // Handle delete
            try {
                const token = localStorage.getItem("jwt-vlada");
                const response = await fetch(
                    `${host}/api/v1/education-applications/${applicationId}`,
                    {
                        method: "DELETE",
                        headers: {
                            Authorization: `Bearer ${token}`,
                        },
                    }
                );

                if (response.ok) {
                    fetchApplications();
                    setError(null);
                } else {
                    setError("Došlo je do greške pri uklanjanju prijave.");
                }
            } catch (err) {
                console.error("Error deleting application:", err);
                setError("Došlo je do greške pri uklanjanju prijave.");
            }
        } else {
            // Handle status update
            try {
                const token = localStorage.getItem("jwt-vlada");
                const response = await fetch(
                    `${host}/api/v1/education-applications/${applicationId}/status`,
                    {
                        method: "PUT",
                        headers: {
                            Authorization: `Bearer ${token}`,
                            "Content-Type": "application/json",
                        },
                        body: JSON.stringify({ status: newStatus }),
                    }
                );

                if (response.ok) {
                    // Refresh applications
                    fetchApplications();
                    const successMessages = {
                        APPROVED: "odobrena",
                        REJECTED: "odbijena",
                        isDelete: false,
                        PENDING: "vraćena na čekanje",
                    };
                    setError(null);
                    // You could add a success message state here if needed
                } else {
                    setError("Došlo je do greške pri ažuriranju statusa.");
                }
            } catch (err) {
                console.error("Error updating status:", err);
                setError("Došlo je do greške pri ažuriranju statusa.");
            }
        }

        setConfirmDialog({
            show: false,
            applicationId: null,
            newStatus: null,
            message: "",
            isDelete: false,
        });
    };

    const cancelStatusUpdate = () => {
        setConfirmDialog({
            show: false,
            applicationId: null,
            newStatus: null,
            message: "",
        });
    };

    const getStatusBadge = (status) => {
        const badges = {
            PENDING: { text: "Na čekanju", className: "status-pending" },
            APPROVED: { text: "Odobreno", className: "status-approved" },
            REJECTED: { text: "Odbijeno", className: "status-rejected" },
        };
        return badges[status] || badges.PENDING;
    };

    const getEducationName = (type) => {
        const names = {
            "hands-on": "Hands-On",
            "look-and-learn": "Look & Learn",
            "one-on-one": "One-on-One",
            fade: "Fade",
            formation: "Formation",
            "creative-formation": "Creative Formation",
            fundamental: "Fundamental",
            "nine-week": "9 Nedeljna",
            "twelve-week": "12 Nedeljna",
            online: "Online",
        };
        return names[type] || type;
    };

    const formatDate = (dateString) => {
        const date = new Date(dateString);
        return date.toLocaleDateString("sr-RS");
    };

    if (loading) {
        return (
            <div className='admin-education-applications'>
                <h1>Učitavanje...</h1>
            </div>
        );
    }

    return (
        <>
            <div className='admin-education-applications'>
                <div style={{ marginBottom: "30px" }}>
                    <h1 style={{ marginBottom: "10px" }}>Prijave Edukacija</h1>
                    <button
                        className='barber-zajednica-admin-button'
                        onClick={() => navigate("/admin")}
                        style={{ marginBottom: "20px" }}
                    >
                        ← Nazad na Admin
                    </button>

                    <div
                        style={{
                            display: "flex",
                            gap: "10px",
                            marginTop: "20px",
                            flexWrap: "wrap",
                        }}
                    >
                        <button
                            onClick={() => setFilterStatus("ALL")}
                            style={{
                                padding: "10px 20px",
                                backgroundColor:
                                    filterStatus === "ALL"
                                        ? "#be9455"
                                        : "#3a3a3a",
                                color: "white",
                                border: "none",
                                borderRadius: "8px",
                                cursor: "pointer",
                                fontSize: "14px",
                            }}
                        >
                            Sve ({applications.length})
                        </button>
                        <button
                            onClick={() => setFilterStatus("PENDING")}
                            style={{
                                padding: "10px 20px",
                                backgroundColor:
                                    filterStatus === "PENDING"
                                        ? "#8b7028"
                                        : "#3a3a3a",
                                color: "white",
                                border: "none",
                                borderRadius: "8px",
                                cursor: "pointer",
                                fontSize: "14px",
                            }}
                        >
                            Na čekanju
                        </button>
                        <button
                            onClick={() => setFilterStatus("APPROVED")}
                            style={{
                                padding: "10px 20px",
                                backgroundColor:
                                    filterStatus === "APPROVED"
                                        ? "#4a6b52"
                                        : "#3a3a3a",
                                color: "white",
                                border: "none",
                                borderRadius: "8px",
                                cursor: "pointer",
                                fontSize: "14px",
                            }}
                        >
                            Odobreno
                        </button>
                        <button
                            onClick={() => setFilterStatus("REJECTED")}
                            style={{
                                padding: "10px 20px",
                                backgroundColor:
                                    filterStatus === "REJECTED"
                                        ? "#7a3d38"
                                        : "#3a3a3a",
                                color: "white",
                                border: "none",
                                borderRadius: "8px",
                                cursor: "pointer",
                                fontSize: "14px",
                            }}
                        >
                            Odbijeno
                        </button>
                    </div>
                </div>

                {error && (
                    <div
                        style={{
                            color: "red",
                            padding: "15px",
                            marginBottom: "20px",
                            backgroundColor: "#ffe6e6",
                            borderRadius: "8px",
                        }}
                    >
                        {error}
                    </div>
                )}

                {applications.length === 0 ? (
                    <div className='empty-state'>
                        <p style={{ fontSize: "18px", color: "#aaa" }}>
                            Nema prijava za odabrani filter.
                        </p>
                    </div>
                ) : (
                    <div
                        style={{
                            display: "grid",
                            gap: "20px",
                        }}
                    >
                        {applications.map((app) => {
                            const statusBadge = getStatusBadge(app.status);
                            return (
                                <div key={app.id} className='application-card'>
                                    <div
                                        style={{
                                            display: "flex",
                                            justifyContent: "space-between",
                                            alignItems: "flex-start",
                                            marginBottom: "15px",
                                            flexWrap: "wrap",
                                            gap: "10px",
                                        }}
                                    >
                                        <div>
                                            <h3
                                                style={{
                                                    fontSize: "20px",
                                                    margin: "0 0 5px 0",
                                                    color: "#be9455",
                                                }}
                                            >
                                                {getEducationName(
                                                    app.educationType
                                                )}
                                            </h3>
                                            <p
                                                style={{
                                                    margin: "0",
                                                    color: "#aaa",
                                                    fontSize: "14px",
                                                }}
                                            >
                                                {app.userName} ({app.userEmail})
                                            </p>
                                        </div>
                                        <span
                                            className={statusBadge.className}
                                            style={{
                                                padding: "6px 14px",
                                                borderRadius: "20px",
                                                fontSize: "12px",
                                                fontWeight: "bold",
                                            }}
                                        >
                                            {statusBadge.text}
                                        </span>
                                    </div>

                                    <div
                                        style={{
                                            color: "#ccc",
                                            fontSize: "14px",
                                            marginBottom: "15px",
                                        }}
                                    >
                                        {(app.slotDate || app.startDate) && (
                                            <p style={{ margin: "8px 0" }}>
                                                📅 <strong>Datum:</strong>{" "}
                                                {formatDate(
                                                    app.slotDate ||
                                                        app.startDate
                                                )}
                                            </p>
                                        )}
                                        {app.startTime && app.endTime && (
                                            <p style={{ margin: "8px 0" }}>
                                                🕐 <strong>Vreme:</strong>{" "}
                                                {app.startTime.substring(0, 5)}{" "}
                                                - {app.endTime.substring(0, 5)}
                                            </p>
                                        )}
                                        <p style={{ margin: "8px 0" }}>
                                            💰 <strong>Cena:</strong> €
                                            {app.totalPrice}
                                        </p>
                                        {app.createdAt && (
                                            <p style={{ margin: "8px 0" }}>
                                                📝 <strong>Prijavljeno:</strong>{" "}
                                                {formatDate(app.createdAt)}
                                            </p>
                                        )}
                                    </div>

                                    <div
                                        style={{
                                            display: "flex",
                                            gap: "10px",
                                            marginTop: "15px",
                                            flexWrap: "wrap",
                                        }}
                                    >
                                        {app.status !== "APPROVED" && (
                                            <button
                                                onClick={() =>
                                                    updateApplicationStatus(
                                                        app.id,
                                                        "APPROVED"
                                                    )
                                                }
                                                style={{
                                                    flex: 1,
                                                    padding: "10px",
                                                    backgroundColor: "#4a6b52",
                                                    color: "white",
                                                    border: "none",
                                                    borderRadius: "8px",
                                                    cursor: "pointer",
                                                    fontSize: "14px",
                                                    fontWeight: "bold",
                                                }}
                                            >
                                                ✓ Odobri
                                            </button>
                                        )}
                                        {app.status !== "REJECTED" && (
                                            <button
                                                onClick={() =>
                                                    updateApplicationStatus(
                                                        app.id,
                                                        "REJECTED"
                                                    )
                                                }
                                                style={{
                                                    flex: 1,
                                                    padding: "10px",
                                                    backgroundColor: "#7a3d38",
                                                    color: "white",
                                                    border: "none",
                                                    borderRadius: "8px",
                                                    cursor: "pointer",
                                                    fontSize: "14px",
                                                    fontWeight: "bold",
                                                }}
                                            >
                                                ✗ Odbij
                                            </button>
                                        )}
                                        {app.status !== "PENDING" && (
                                            <button
                                                onClick={() =>
                                                    updateApplicationStatus(
                                                        app.id,
                                                        "PENDING"
                                                    )
                                                }
                                                style={{
                                                    flex: 1,
                                                    padding: "10px",
                                                    backgroundColor: "#8b7028",
                                                    color: "white",
                                                    border: "none",
                                                    borderRadius: "8px",
                                                    cursor: "pointer",
                                                    fontSize: "14px",
                                                    fontWeight: "bold",
                                                }}
                                            >
                                                ↻ Vrati na čekanje
                                            </button>
                                        )}
                                        <button
                                            onClick={() =>
                                                deleteApplication(app.id)
                                            }
                                            style={{
                                                flex: "0 0 100%",
                                                padding: "10px",
                                                backgroundColor: "#555",
                                                color: "white",
                                                border: "none",
                                                borderRadius: "8px",
                                                cursor: "pointer",
                                                fontSize: "14px",
                                                fontWeight: "bold",
                                                marginTop: "5px",
                                            }}
                                        >
                                            🗑️ Ukloni iz liste
                                        </button>
                                    </div>
                                </div>
                            );
                        })}
                    </div>
                )}
            </div>

            {/* Confirmation Dialog */}
            {confirmDialog.show && (
                <div className='modal-overlay'>
                    <div
                        className='modal-content'
                        style={{ maxWidth: "500px" }}
                    >
                        <h2 style={{ color: "#be9455" }}>
                            {confirmDialog.isDelete
                                ? "Uklanjanje prijave"
                                : confirmDialog.newStatus === "REJECTED"
                                ? "Odbijanje prijave"
                                : confirmDialog.newStatus === "APPROVED"
                                ? "Odobravanje prijave"
                                : "Vraćanje na čekanje"}
                        </h2>
                        <div className='form-section'>
                            <p
                                style={{
                                    fontSize: "16px",
                                    lineHeight: "1.6",
                                    marginBottom: "15px",
                                    color: "#ffffff",
                                }}
                            >
                                {confirmDialog.message}
                            </p>
                            {confirmDialog.isDelete && (
                                <p
                                    style={{
                                        fontSize: "14px",
                                        color: "#ff9999",
                                        lineHeight: "1.6",
                                    }}
                                >
                                    Ova akcija će trajno sakriti prijavu iz
                                    liste.
                                </p>
                            )}
                            {confirmDialog.newStatus === "REJECTED" && (
                                <p
                                    style={{
                                        fontSize: "14px",
                                        color: "#ff9999",
                                        lineHeight: "1.6",
                                    }}
                                ></p>
                            )}
                            {confirmDialog.newStatus === "APPROVED" && (
                                <p
                                    style={{
                                        fontSize: "14px",
                                        color: "#88d4a0",
                                        lineHeight: "1.6",
                                    }}
                                ></p>
                            )}
                        </div>
                        <div className='modal-actions'>
                            <button
                                className='btn-save'
                                onClick={confirmStatusUpdate}
                                style={{
                                    backgroundColor: confirmDialog.isDelete
                                        ? "#555"
                                        : confirmDialog.newStatus === "REJECTED"
                                        ? "#e74c3c"
                                        : confirmDialog.newStatus === "APPROVED"
                                        ? "#4a6b52"
                                        : "#be9455",
                                    minWidth: "120px",
                                }}
                            >
                                Da, potvrdi
                            </button>
                            <button
                                className='btn-cancel'
                                onClick={cancelStatusUpdate}
                                style={{ minWidth: "120px" }}
                            >
                                Otkaži
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </>
    );
};
